<template>
  <v-main>
    <v-container fluid>
      <v-alert id="paramAlert" v-model="alertState.isAlert" :type="alertState.type" closable class="row" @click:close="alertState.reset()">{{ alertState.message }}</v-alert>
      <v-alert id="alert" v-model="login.alert.isAlert" :type="login.alert.type" closable class="row">{{ login.alert.message }}</v-alert>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-card-title>ログイン情報を入力してください。</v-card-title>
            <v-spacer></v-spacer>
            <v-card-text>
              <v-form>
                <v-text-field
                  id="userId"
                  v-model="login.userId"
                  :prepend-icon="mdiAccount"
                  placeholder="ログインID"
                  type="text"
                  maxlength="256"
                  variant="underlined"
                  density="compact"
                  @keyup.enter="exec"
                ></v-text-field>
                <v-text-field
                  id="password"
                  v-model="login.password"
                  :prepend-icon="mdiLock"
                  placeholder="パスワード"
                  type="password"
                  maxlength="256"
                  variant="underlined"
                  density="compact"
                  @keyup.enter="exec"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn id="login" class="ml-10" variant="elevated" color="primary" :disabled="isButtonDisabled" @click="exec">ログイン</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-card-text align="left">
                <router-link id="toPasswordReissue" :to="{ name: 'PasswordReissue' }">パスワード設定</router-link>
              </v-card-text>
              <v-card-text align="right">
                <router-link id="toUserIdReissue" :to="{ name: 'UseridReissue' }">ログインID再通知</router-link>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-card-text>
              対応ブラウザ：Chrome(最新版)、Microsoft Edge(最新版)<br />
              ※Internet explorer非対応<br />
              ※本サイトを利用するにはCookieを有効にする必要があります。
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import UserRole from '@/constants/userrole';
import { mdiAccount, mdiLock } from '@mdi/js';
import { useAlertStore } from '../stores/alert';

export default {
  setup() {
    const alertState = useAlertStore();
    return {
      alertState,
    };
  },
  data: () => ({
    login: {
      userId: '',
      password: '',
      alert: {
        isAlert: false,
        type: 'success',
        message: '',
      },
    },
    isButtonDisabled: false,
    alert: { isAlert: false, type: 'success', message: '' },
    cookie: { isValid: false },
    mdiAccount,
    mdiLock,
  }),
  unmounted() {
    this.alertState.reset();
  },
  mounted: function () {
    this.checkCookieValid();
  },
  created: function () {
    this.$cookies.remove('access_token');
  },
  methods: {
    exec: function () {
      this.checkCookieValid();
      if (this.cookie.isValid) {
        this.doLogin();
      }
    },
    doLogin: async function () {
      this.isButtonDisabled = true;
      try {
        let loginResponse = await this.axios.post(Api.PATH_LOGIN, {
          mypage_user_id: this.login.userId,
          mypage_user_password: this.login.password,
        });
        if (loginResponse != null && loginResponse.data != null) {
          if (loginResponse.data.status == Api.STATUS_SUCCESS) {
            if (loginResponse.data.exists_billinggroup) {
              this.$cookies.set('access_token', loginResponse.data.access_token);
              console.log('loginResponse', loginResponse.data);
              if (loginResponse.data.role_id == UserRole.BILLINGUSER) {
                this.$router.push({ name: 'InvoicesList' });
              } else {
                sessionStorage.setItem('is_first_login', true);
                this.$router.push({ name: 'BillingsList' });
              }
            } else {
              this.login.userId = '';
              this.login.password = '';
              this.showAlert('warning', 'ログインできませんでした。');
              return;
            }
          } else if (loginResponse.data.status == Api.STATUS_ACCOUNT_LOCKED) {
            this.login.userId = '';
            this.login.password = '';
            this.showAlert('warning', 'このログインIDはロックされています。');
            return;
          } else {
            this.login.userId = '';
            this.login.password = '';
            this.showAlert('warning', 'ログインID又はパスワードが正しくありません。');
            return;
          }
        } else {
          throw 'API_LOGIN failed.';
        }
      } finally {
        this.isButtonDisabled = false;
      }
    },
    showAlert: function (type, message) {
      this.login.alert.isAlert = true;
      this.login.alert.type = type;
      this.login.alert.message = message;
    },
    checkCookieValid: function () {
      if (navigator.cookieEnabled) {
        this.cookie.isValid = true;
      } else {
        this.showAlert('warning', 'Cookieが有効ではありません。');
        this.cookie.isValid = false;
      }
    },
  },
};
</script>